<template>
  <div id="results-dashboard" v-if="results">
    <modal v-model="select.show" :header="false" :footer="select.listMode"
           @hide="select.hide($event)" size="lg">
      <template slot="footer">
        <btn @click="select.none()">Tout déselectionner</btn>
        <btn @click="select.all()">Tout sélectionner</btn>
        <btn type="success" @click="select.hide('ok')">Ok</btn>
      </template>
      <div class="row">
        <div class="select-container">
          <span v-for="(s, k) in specialitiesSelectors"
                :key="`${k}-selector`"
                :class="`col-xs-12 col-sm-${s[0].col}`">
            <selector :lines="s" type="dark">
            </selector>
          </span>
        </div>
      </div>
    </modal>
    <div ref="tabsnav">
      <modal v-model="help"
             :footer="false"
             size="lg"
             title="Informations sur les résultats">
        <sui-how-to-read-results :hideContact="true"></sui-how-to-read-results>
      </modal>

      <div class="tabs hidden-xs hidden-sm">
        <ul role="tablist" class="nav nav-tabs">
          <li role="presentation" :class="{ 'active': tab === 0 }" v-if="displayIndicators">
            <a role="button" @click="tab = 0">
              Indicateurs
              <small v-if="tabSubtitle"><br>{{tabSubtitle.indic}}</small>
            </a>
          </li>
          <li role="presentation" :class="{ 'active': tab === 1 }">
            <a role="button" @click="tab = 1">
              Tableaux
              <small v-if="tabSubtitle"><br>{{tabSubtitle.type}}</small>
            </a>
          </li>
          <li role="presentation" :class="{ 'active': tab === 2 }">
            <a role="button"
               @click="tab = 2">Graphiques
              <small v-if="tabSubtitle"><br>{{tabSubtitle.type}}</small>
            </a>
          </li>
          <li v-if="caracteristics != null"
              role="presentation" :class="{ 'active': tab === 3 }">
            <a role="button" @click="tab = 3">Caractéristiques
              <small v-if="tabSubtitle"><br>{{tabSubtitle.carac}}</small>
            </a>
          </li>
          <li role="presentation" class="pull-right">
            <a role="button" @click="help = true">
              Comment lire les résultats
              <span class="glyphicon glyphicon-question-sign"
                    style="margin-left: 0.3rem"
                    aria-hidden="true"></span>
            </a>
          </li>
        </ul>
      </div>
      <div class="visible-xs visible-sm">
        <div class="small-tabs">
          <btn type="default" @click="help = true" size="sm"
               class="pull-right">
            Aide
            <span class="glyphicon glyphicon-question-sign"
                  style="margin-left: 0.3rem"
                  aria-hidden="true"></span>
          </btn>
          <btn size="sm" :type="tab === 0 ? 'primary' : 'default'"
               @click="tab = 0">
            Indicateurs
          </btn>
          <btn size="sm" :type="tab === 1 ? 'primary' : 'default'"
               @click="tab = 1">
            Tableaux
          </btn>
          <btn size="sm" :type="tab === 2 ? 'primary' : 'default'"
               @click="tab = 2">
            Graphiques
          </btn>
          <btn size="sm" :type="tab === 3 ? 'primary' : 'default'"
               v-if="caracteristics != null"
               @click="tab = 3">
            Caractéristiques
          </btn>
        </div>
      </div>
    </div>
    <span ref="content"></span>
    <div v-if="tab === 0">
      <h3 v-if="isRegional">Indicateurs nationaux
        <span v-if="tabSubtitle && tabSubtitle.type !== 'TOUS'">
          (type d'établissement : {{tabSubtitle.type}})
        </span>
      </h3>
      <sui-indicators :value="indicatorsData" @select="showChart">
      </sui-indicators>
    </div>
    <div v-else-if="tab === 1">
      <div v-sticky sticky-offset="selectorStickyOffset" class="sticky-bar">
        <div class="selectors text-center hidden-lg hidden-xl">
          <dropdown-selector
              type="results" :label="infectionType.shortName"
              :lines="infectionTypeLines" size="xs">
          </dropdown-selector>
          <dropdown-selector :label="denominatorsLines.label"
              :keepOpen="true" type="reaExplaur"
              :lines="denominatorsLines.choices" size="xs">
          </dropdown-selector>
          <dropdown-selector :label="filter.name" type="observa4"
              :lines="filterLines" size="xs">
          </dropdown-selector>
          <dropdown-selector type="diaInfADI" :label="scope.name"
              :lines="entrancesLines" size="xs">
          </dropdown-selector>
        </div>

        <div class="visible-lg">
          <div class="selectors text-center">
            <div>
              <h4 class="txt-dark-results">Infection</h4>
              <dropdown-selector
                type="results" :label="infectionType.shortName"
                :lines="infectionTypeLines">
              </dropdown-selector>
            </div>
            <div>
              <h4 class="txt-dark-reaExplaur">Dénominateurs</h4>
              <dropdown-selector :label="denominatorsLines.label"
                                 :keepOpen="true" type="reaExplaur"
                                 :lines="denominatorsLines.choices">
              </dropdown-selector>
            </div>
            <div>
              <h4 class="txt-dark-observa4">Lignes</h4>
              <dropdown-selector :label="filter.name" type="observa4"
                                 :lines="filterLines">
              </dropdown-selector>
            </div>
            <div>
              <h4 class="txt-diaInfADI">Colonnes</h4>
              <dropdown-selector type="diaInfADI" :label="scope.name"
                                 :lines="entrancesLines">
              </dropdown-selector>
            </div>
          </div>
        </div>
        <div class="results-action-bar">
          <btn @click="exportPDF" size="xs">
            <span class="glyphicon glyphicon-download-alt"
                  aria-hidden="true">
            </span>
            Exporter en PDF
          </btn>
          <btn @click="exportCSV" type="info" size="xs">
            <span class="glyphicon glyphicon-download-alt"
                  aria-hidden="true">
            </span>
            Exporter en CSV
          </btn>
          <save-blob :target="csv"></save-blob>
        </div>
        <div>
          <span class="alert alert-info mini-alert" v-if="listFilter !== ''">
            <span class="glyphicon glyphicon-alert"
                  aria-hidden="true">
            </span>
            <strong>
              Filtre actif !
              <span class="hidden-xs">
                Les taux d'incidence sont modifiés en conséquence.
              </span>
            </strong>
          </span>
          <span class="alert alert-partial mini-alert" v-if="results.hasPartial">
            <span class="glyphicon glyphicon-alert"
                  aria-hidden="true">
            </span>
            <strong>
              Taux d'incidence par Discipline incomplets !
              <span class="hidden-xs hidden-lg">
                Préférez le sélecteur «Ufs».
              </span>
              <span class="visible-lg-inline-block">
                Nous vous recommandons d'utiliser le sélecteur «Ufs».
              </span>
            </strong>
          </span>
        </div>
        <table class="table table-responsive">
          <thead>
            <tr>
              <th class="fixed-column text-center">Discipline</th>
              <th class="fixed-column text-center">UF</th>
              <th v-for="(c, k) in currentScopeEntrances"
                  class="text-center txt-diaInfADI"
                  :style="{ 'background-color': c.background || '#fff' }"
                  :key="`column-${k}`">
                <span v-tooltip="c.info.tooltip">{{ c.info.title }}</span>
              </th>
            </tr>
          </thead>
        </table>
      </div>
      <div v-for="d in denominators"
           v-if="unitLists[currentDenominators[d].code] != null && unitLists[currentDenominators[d].code].length > 0"
           :key="`denominator-${d}`">
        <incidence-table :title="currentDenominators[d].info.label"
                         :denominator="currentDenominators[d]"
                         :type="infectionType"
                         :columns="currentScopeEntrances"
                         :lines="unitLists"
                         :values="incidences"
                         @select="showChart">
        </incidence-table>
      </div>
    </div>
    <div v-else-if="tab === 2" class="chart-tab">
        <h3>
          Graphique de répartition des taux d'incidence des infections
          surveillées
        </h3>
        <div v-if="establishmentType">
          <div v-if="disableChartOnFilter && listFilter !== ''">
            <alert type="warning">
            <h4>Filtre actif : graphiques non disponibles</h4>
            <p>
              Les populations affichées sur les graphiques ne prennent pas en
              compte les filtres, il n'est donc pas possible de se comparer
              avec les autres établissements avec des données filtrées.
            </p>
          </alert>
          </div>
          <div v-else>
            <p class="text-justify">
              Utilisez les sélecteurs ci-dessous pour générer les graphiques
              de répartition des taux d'incidence des infections surveillées.
            </p>
            <div class="row">
              <div class="col-xs-12 col-lg-6">
                <selector :lines="graphInfectionTypeLines"></selector>
                <selector type="dark" :lines="populationLines"
                          v-if="populationLines.length > 0"></selector>
                <selector v-if="graphDenominatorsLines.length > 0"
                          :lines="graphDenominatorsLines"></selector>
                <selector v-if="graphEntrancesLines.length > 0"
                          type="dark" :lines="graphEntrancesLines"></selector>
                <selector :lines="establishmentLines"
                      v-if="establishmentLines.length > 0">
                </selector>
                <selector type="dark" :lines="graphOptions"
                          v-if="graphOptions.length > 0"></selector>
              </div>
              <div class="col-xs-12 col-lg-6">
                <span class="alert alert-info mini-alert"
                      v-if="listFilter !== ''">
                  <span class="glyphicon glyphicon-alert"
                        aria-hidden="true">
                  </span>
                  Filtre actif !
                  <span class="hidden-xs">
                    Les taux d'incidence sont modifiés en conséquence.
                  </span>
                </span>
                <alert type="warning" v-if="year === chartYear + 1">
                    <h4><strong>Attention : résultats provisoires !</strong></h4>
                  <p>
                    <strong>
                      Les données nationales de l'année {{year}} étant
                      incomplètes, les graphiques utilisent les populations de
                      la surveillance {{chartYear}}.
                    </strong>
                  </p>
                </alert>
                <alert type="warning" class="text-justify" v-if="customDataset">
                  <h4>Graphique issu de données personnalisées</h4>
                  <p>
                    Le taux d'incidence affiché correspond au taux d'incidence
                    obtenu à partir de la période spécifiée dans vos données
                    personnalisées.
                  </p>
                  <p>
                    La population affichée correspond à la population obtenue à
                    partir des données des 3 mois de surveillance nationale.
                  </p>
                </alert>
                <chart type="boxplot-chart"
                       :minExportSize="10"
                       v-if="chartAvailable"
                       nested
                       :plugins="plotPlugins"
                       :exportConfig="plotExportConfig"
                       :config="plotConfig">
                </chart>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <alert type="warning">
            <h4>Graphiques non disponibles</h4>
            <p>
              Le type d'établissement n'est pas rempli dans la Fiche
              Établissement, empêchant la création des graphiques de
              répartition.
            </p>
          </alert>
        </div>
    </div>
    <div v-show="tab === 3">
      <span class="alert alert-info mini-alert" v-if="listFilter !== ''">
        <span class="glyphicon glyphicon-alert"
              aria-hidden="true">
        </span>
        Filtre actif !
        <span class="hidden-xs">
          Les caractéristiques sont modifiées en conséquence.
        </span>
      </span>
      <caracteristics
        :caracteristics="caracteristics"
        :title="caracteristicsTitle"
        :subtitle="caracteristicsSubtitle">
        <h3>Aucune infection</h3>
        <p>
          Aucune infection n'a été déclarée dans votre établissement.
        </p>
      </caracteristics>
    </div>
  </div>
</template>
<script>
import chart from '@/sui/components/charts/chart'
import incidenceTable from '@/sui/components/results/incidenceTable'
import caracteristics from '@/sui/components/results/caracteristics'
import selector from '@/sui/components/results/selector'
import readResults from '@/sui/components/results/readResults'

import debounce from 'debounce'

import saveBlob from '@/sui/components/saveblob'
import dropdownSelector from '@/sui/components/results/dropdownSelector'
import sc from '@/sui/components/results/sc/dashboard'
import impl from '@/sui/components/results/impl/dashboard'
import results from '@/sui/data/results'
import options from '@/sui/tools/chart/options'
import indicators from '@/sui/components/results/indicators'

export default {
  name: 'result-dashboard',

  props: {
    results: {
      type: Object,
      required: true
    },

    otherTypeResults: {
      type: Object,
      default: null
    },

    chartTitle: {
      type: String,
      required: true
    },

    showValuesToggle: {
      type: Boolean,
      default: false
    },

    showHiddenScopes: {
      type: Boolean,
      default: false
    },

    pdfOptions: {
      type: Object,
      default: () => {
        return {
          legend: true,
          showUfs: true,
          showMean: true
        }
      }
    },

    caracteristics: {
      type: Array,
      default: null
    },

    regionalIndicators: {
      type: Object,
      default: null
    },

    flattenedRegionalIndicator: {
      type: Array,
      default: null
    },

    getStatisticsOverride: {
      type: Function,
      default: null
    },

    region: {
      type: String,
      default: ''
    },

    year: {
      type: Number,
      required: true
    },

    chartYear: {
      type: Number,
      required: true
    },

    referenceDataset: {
      type: String,
      required: true
    },

    listFilter: {
      type: String,
      default: ''
    },

    disableChartOnFilter: {
      type: Boolean,
      default: true
    },

    stickyOffset: {
      type: Number,
      default: 0
    },

    tabSubtitle: {
      type: Object,
      default: null
    }
  },

  data: function () {
    const infectionType = sc.infectionTypes[0]
    return {
      unfold: {
        den: false,
        inf: false,
        ent: false,
        fil: false
      },
      csv: null,
      help: false,
      referenceScrolling: null,
      selectorStickyOffset: {
        top: this.stickyOffset
      },
      showValues: true,
      showOutlierLimit: true,
      showIndicatorLimit: true,
      tab: 0,
      tabOffset: [-1, -1, -1],
      sc: sc,
      scope: sc.scopes[infectionType.code][0],
      filter: sc.filters[0],
      infectionType: infectionType,
      denominators: [],
      graph: {
        denominator: null,
        infectionType: null,
        entrances: impl.data.entrances(this),
        etypes: impl.data.etypes
      },

      select: impl.data.select(this, sc)
    }
  },

  mounted: function () {
    const top = this.$refs.content.getBoundingClientRect().top
    this.referenceScrolling = window.pageYOffset - this.stickyOffset + top - 45

    this.reset()
  },

  methods: {
    setFirstTab: function () {
      this.tab = this.displayIndicators ? 0 : 1
    },

    resetDenominators: function (s) {
      this.denominators = []
    },

    showChart: function (r) {
      this.select.population = r.p
      this.select.selection = r.u
      this.graph.denominator = this.currentDenominators.find(
        d => d.code === r.d.code
      )
      this.graph.infectionType = r.i
      this.graph.entrances.values.length = 0

      const scope = this.scopes[r.i.code]
      for (let i = 0; i !== scope.length; ++i) {
        const list = scope[i].entrances
        const entrance = list.find(elt => elt.code === r.c.code)
        if (entrance != null) {
          this.graph.entrances.toggle(entrance)
          break
        }
      }

      this.graph.etypes.values.length = 0
      this.tab = 2
    },

    exportPDF: function () {
      const vm = this
      this.select.showModal(
        'pdf',
        (msg) => {
          if (msg === 'ok' && vm.select.pdfList.length > 0) {
            impl.tools.exportPDF(
              vm, sc,
              (vm, u) => {
                return vm.select.pdfList.indexOf(u) !== -1
              },
              vm.pdfOptions
            )
          }
        }
      )
    },

    exportCSV: function () {
      impl.tools.exportCSV(this)
    },

    getIncidence: function (etype, key) {
      const otr = this.otherTypeResults
      if (otr == null) {
        return null
      }

      const or = otr.values
      if (or == null || or[etype] == null) {
        return null
      }

      const result = or[etype].values[key]
      if (otr.noQuality) {
        return {
          divisor: result.divisor,
          incidence: result.incidence,
          mean: result.mean,
          numerator: result.numerator,
          quality: 4
        }
      }
      return result
    },

    reset: function () {
      this.setFirstTab()
      this.select.show = false
      impl.tools.resetArray(this.select.list)
      this.select.population = null
      this.select.selection = null
      this.graph.denominator = null
      this.graph.infectionType = null

      impl.tools.resetArray(this.graph.entrances.values)
      impl.tools.resetArray(this.graph.etypes.values)
      impl.tools.resetArray(this.denominators)
      this.infectionType = sc.infectionTypes[0]
      this.filter = sc.filters[0]
      this.scope = this.scopes[this.infectionType.code][0]
      this.resetDenominators(this.infectionType.code)
    },

    selectFilter: function (i) {
      const f = sc.filters[i]
      this.filter = f
      if (f.click != null) {
        f.click(this)
      }
    },

    checkDenominator: function (val) {
      const d = this.graph.denominator
      if (d != null) {
        const units = this.results.units[this.graph.infectionType.code][d.code]
        if (units == null || units.findIndex(u => u.uf === val.uf && u.spe === val.spe) === -1) {
          this.graph.denominator = null
        }
        this.checkEntrances()
        this.resetETypes()
      }
    },

    checkEntrances: function () {
      const val = this.select.selection
      const t = this.graph.infectionType
      const d = this.graph.denominator
      if (val != null && d != null) {
        const entrances = this.graph.entrances.values.slice()
        if (entrances != null && entrances.length > 0) {
          impl.tools.resetArray(this.graph.entrances.values)
          entrances.forEach(
            e => {
              const key = results.getIncidenceKey(
                {
                  inf: t.code,
                  den: d.code,
                  ent: e.code,
                  disc: val.disc,
                  spe: val.spe,
                  uf: val.uf
                }
              )
              if (this.incidences[key] != null) {
                this.graph.entrances.values.push(e)
              }
            }
          )
        }
      }
    },

    resetETypes: function () {
      const entrances = this.graph.entrances.values
      if (entrances != null && entrances.length > 0) {
        const etypes = this.graph.etypes.values
        if (etypes != null && etypes.length > 0) {
          impl.tools.resetArray(etypes)
        }
      }
    },

    dispatchLoadStatistics: function () {
      if (this.graph.infectionType != null &&
          this.graph.denominator != null &&
          this.select.population != null) {
        this.graph.entrances.values.forEach(
          e => {
            const request = {
              dset: this.referenceDataset,
              inf: this.graph.infectionType.code,
              den: this.graph.denominator.code,
              ent: e.code,
              disc: this.select.population.disc,
              spe: this.select.population.spe
            }
            this.$store.dispatch(
              'results/loadStatistics',
              request
            )
          }
        )
      }
    }
  },

  computed: {
    isRegional: function () {
      return this.regionalIndicators !== null
    },

    displayIndicators: function () {
      return Object.keys(this.indicatorsData).length !== 0
    },

    indicatorsData: function () {
      if (this.isRegional) {
        return this.regionalIndicators
      }
      return results.computeIndicators(this.results.values)
    },

    customDataset: function () {
      return !this.chartTitle.toLowerCase().startsWith('spiadi')
    },

    indicatorsTitle: function () {
      return `${this.chartTitle} - Indicateurs`
    },

    indicatorsSubtitle: function () {
      if (this.listFilter === '') {
        return ''
      }

      return `Filtre actif : ${this.listFilter}`
    },

    caracteristicsTitle: function () {
      return `${this.chartTitle} - Caractéristique des infections`
    },

    caracteristicsSubtitle: function () {
      if (this.listFilter === '') {
        return ''
      }

      return `Filtre actif : ${this.listFilter}`
    },

    getStatistics: function () {
      const s = this.getStatisticsOverride
      if (s != null) {
        return s
      }

      return this.$store.getters['results/getStatistics']
    },

    currentUnitList: function () {
      if (this.tab === 1) {
        return this.results.unitList[this.infectionType.code]
      }

      if (this.graph.infectionType == null) {
        return []
      }

      return this.results.unitList[this.graph.infectionType.code]
    },

    currentDenominators: function () {
      return sc.denominators[this.infectionType.code].filter(
        d => (!d.hidden || this.showHiddenScopes) &&
          (d.year == null || d.year <= this.year)

      )
    },

    currentScopeEntrances: function () {
      return this.scope.entrances.filter(
        e => e.info.year == null || e.info.year <= this.year
      )
    },

    scopes: function () {
      const result = {}

      for (let i in sc.scopes) {
        const a = sc.scopes[i].filter(
          s => (!s.hidden || this.showHiddenScopes) &&
              (s.year == null || s.year <= this.year)
        )
        result[i] = a
      }
      return result
    },

    loadStatistics: function () {
      if (this.statistics == null) {
        return debounce(this.dispatchLoadStatistics, 50)
      }

      return () => {}
    },

    chartAvailable: function () {
      return this.select.population != null &&
             this.graph.infectionType &&
             this.graph.denominator != null &&
             this.graph.entrances.values.length > 0
    },

    filterLines: function () {
      return impl.selectors.array.filters(this, sc)
    },

    entrancesLines: function () {
      return impl.selectors.array.entrances(this, sc)
    },

    denominatorsLines: function () {
      return impl.selectors.array.denominators(
        this, sc, ['kt', 'ji', 'jhc', 'jhi', 'sea']
      )
    },

    infectionTypeLines: function () {
      return impl.selectors.array.infectionTypes(this, sc)
    },

    graphInfectionTypeLines: function () {
      return impl.selectors.graph.infectionTypes(this, sc)
    },

    graphDenominatorsLines: function () {
      return impl.selectors.graph.denominators(this, sc)
    },

    graphEntrancesLines: function () {
      return impl.selectors.graph.entrances(this, sc)
    },

    graphOptions: function () {
      return impl.selectors.graph.options(this, sc)
    },

    graphIndicatorLimit: function () {
      const entrances = this.graph.entrances.values
      if (!this.chartAvailable || entrances.length !== 1) {
        return null
      }

      return results.getIndicatorLimit(
        this.graph.infectionType.code,
        this.select.population.disc,
        this.select.population.spe,
        entrances[0].code,
        this.graph.denominator.code
      )
    },

    establishmentLines: function () {
      return impl.selectors.graph.establishments(this, sc)
    },

    populationLines: function () {
      return impl.selectors.graph.population(this, sc)
    },

    specialitiesSelectors: function () {
      return impl.selectors.specialities(this, sc)
    },

    establishmentType: function () {
      return this.results.type
    },

    incidences: function () {
      return this.results.values
    },

    specialities: function () {
      return sc.specialities(this.year)
    },

    unitLists: function () {
      const list = {}

      const vm = this
      const filter = this.filter.filter
      const t = this.infectionType.code
      const units = this.results.units[t]
      const checkScope = function (d, u) {
        for (let i in vm.scope.entrances) {
          const e = vm.scope.entrances[i].code
          const key = results.getIncidenceKey(
            { inf: t, den: d, ent: e, disc: u.disc, spe: u.spe, uf: u.uf }
          )
          const inc = vm.incidences[key]
          if (inc != null) {
            return true
          }
        }
      }

      const specialities = Object.values(vm.specialities)
      for (let d in units) {
        const reducer = (result, u) => {
          if (filter(vm, u) && checkScope(d, u)) {
            //      const spe = u.spe === 'pedSld' ? vm.specialities.pedSLD : vm.specialities[u.spe]

            const isDisc = u.spe === '__all__'
            const spe = specialities.find(
              s => (isDisc && s.code === u.disc) ||
                 (s.code === u.spe && u.spe !== u.disc)
            )
            if (!isDisc && spe == null) {
              return result
            }
            const label = isDisc ? u.disc : u.spe
            result.push({
              src: u,
              uf: u.uf,
              disc: u.disc,
              spe: u.spe,
              label: label,
              sortIndex: spe.sortIndex
            })
          }
          return result
        }
        list[d] = units[d].reduce(reducer, []).sort(
          (f, s) => {
            const si = s.sortIndex != null ? s.sortIndex : 0
            const fi = f.sortIndex != null ? f.sortIndex : 0
            const compare = si - fi
            if (compare === 0) {
              return f.uf.localeCompare(s.uf)
            }
            return compare
          }
        )
      }
      return list
    },

    plotPlugins: function () {
      return impl.chart.plugins(this)
    },

    plotTitles: function () {
      return impl.chart.titles(this, sc)
    },

    plotConfig: function () {
      return impl.chart.config(this, sc)
    },

    plotExportConfig: function () {
      const result = [
        options.titleFontSize(14),
        options.subtitleFontSize(11),
        options.axesFontSize,
        options.datalabelFontSize(),
        options.maxYValue(`Taux d'incidence maximal`),
        options.minYValue(`Taux d'incidence minimal`),
        options.boxplotPercentWidth(
          this.plotConfig.options.scales.xAxes[0].barPercentage * 100
        ),
        options.toggleQ1Q3(),
        options.toggleStandardDeviation()
      ]
      return result
    }
  },

  watch: {
    'result': function () {
      this.reset()
    },

    denominatorsLines: function (v) {
      if (v == null || v.choices.length === 0 || this.denominators.length > 0) {
        return
      }

      let count = 0
      for (let i = 0; i !== v.choices.length; ++i) {
        const current = v.choices[i]
        if (current.initialSelect) {
          current.select()
          ++count
        }
      }

      if (count === 0) {
        v.choices[0].select()
      }
    },

    'select.selection': function (val, old) {
      if (val != null && old != null) {
        this.checkDenominator(val)
      } else if (val == null) {
        this.graph.denominator = null
      }

      this.loadStatistics()
    },

    'graph.infectionType': function (val, old) {
      if (val != null && old != null) {
        const s = this.select.selection
        if (s != null) {
          if (this.currentUnitList.indexOf(s) === -1) {
            this.select.population = null
            this.select.selection = null
          } else {
            this.checkDenominator(s)
          }
        }
      }
    },

    'graph.denominator': function (val) {
      this.loadStatistics()
      if (val != null) {
        this.checkEntrances()
        this.resetETypes()
      }
    },

    'graph.entrances.values': function (val, old) {
      this.loadStatistics()
      if (val.length <= 1 && old.length <= 1 && val[0] !== old[0]) {
        this.resetETypes()
      }
    },

    stickyOffset: function (val) {
      this.selectorStickyOffset.top = val
    },

    tab: function (val, old) {
      if (old != null) {
        const ref = this.referenceScrolling
        const off = window.pageYOffset
        this.tabOffset[old] = (off > ref ? off : ref)

        if (this.tabOffset[val] === -1) {
          this.tabOffset[val] = ref
        }
        if (off >= ref - 10) {
          this.$nextTick(
            () => { window.scrollTo(0, this.tabOffset[val]) }
          )
        }
      }
    },

    caracteristics: function (val) {
      if (val == null && this.tab === 2) {
        this.setFirstTab()
      }
    },

    establishmentType: function (val) {
      this.resetETypes()
    },

    statistics: function (v, o) {
      if (v !== o) {
        this.loadStatistics()
      }
    }
  },

  components: {
    'incidence-table': incidenceTable,
    'selector': selector,
    'chart': chart,
    'caracteristics': caracteristics,
    'save-blob': saveBlob,
    'dropdown-selector': dropdownSelector,
    'sui-how-to-read-results': readResults,
    'sui-indicators': indicators
  }
}
</script>
<style scoped lang="less">
@import '~variables';
@import '~modules';

.tabs {
  padding-top: 1rem;
  margin-bottom: 1rem;
}

.small-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;

  padding-bottom: 1rem;
  background-color: white;
}

.selectors, .tabs, .small-tabs {
  background-color: white;
}

.top-sticky .selectors {
  padding-top: 1rem;
  @media (min-width: 0) and (max-width: @screen-sm-max) {
    padding-top: 52px;
  }
}

.table {
  margin-bottom: 0px;
  table-layout: fixed;
  @media (min-width: 0) and (max-width: @screen-xs-max) {
    font-size: 85%;
  }
  border-top: 1px solid #ddd;
}

.chart-tab {
  min-height: 70rem;
}

.alert-partial {
  background-color: lighten(#c68dc3, 15%);
  color: darken(#c68dc3, 25%);
}

.mini-alert {
  display: inline-block;
  margin-bottom: 0rem;
  height: 100%;
  padding: 5px 10px;
  font-size: 12px;
  vertical-align: middle;
  line-height: 1.5;
  width: 100%;

  .glyphicon {
    margin: 0rem 0.5rem 0rem 0.2rem;
  }
}

.results-action-bar {
  gap: 1rem;
  display: flex;
  justify-content: center;
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  .btn {
    margin-right: 0.2rem;
  }
  .mini-alert {
    width: auto;
  }
}

#results-dashboard {
  margin-bottom: 30rem;
}

.selectors {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
  margin-bottom: 0.5rem;
  h4 {
    margin-bottom: 0.2rem;
  }
}

@media (max-width: @screen-md-max) {
  .selectors {
    gap: 0.2rem;
  }
}

.sticky-bar {
  background-color: white;
}

.left-border {
  border-left: 1px solid #ddd;
}

</style>
